export const GEMINI_FIELD_NAME = {
	DESCRIPTION: "description",
};

export const FILE_NAME = {
	NO_MEDIA_PROVIDED: "No Media Provided.png",
};
